function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import React from "react";
import { withContentRect } from "react-measure";
import { shallowEqual } from "./common";
import { PACKAGE_VERSION } from "./constants";
import constructUrl from "./constructUrl";
import extractQueryParams from "./extractQueryParams";
import findClosest from "./findClosest";
import targetWidths from "./targetWidths";
import { mergeComponentPropsHOF, processPropsHOF } from "./HOFs";
var findNearestWidth = function findNearestWidth(actualWidth) {
  return findClosest(actualWidth, targetWidths);
};
var toFixed = function toFixed(dp, value) {
  return +value.toFixed(dp);
};
export var __shouldComponentUpdate = function __shouldComponentUpdate(props, nextProps) {
  var contentRect = props.contentRect;
  var bounds = contentRect.bounds;
  var prevWidth = bounds.width,
    prevHeight = bounds.height;
  var nextContentRect = nextProps.contentRect;
  var nextBounds = nextContentRect.bounds;
  var nextWidth = nextBounds.width,
    nextHeight = nextBounds.height;

  // If neither of the previous nor next dimensions are present,
  // re-render.
  if (!nextWidth || !nextHeight || !prevWidth || !prevHeight) {
    return true;
  }

  // The component has been rendered at least twice by this point
  // and both the previous and next dimensions should be defined.
  // Only update if the nextWidth is greater than the prevWidth.
  if (prevWidth && nextWidth && nextWidth > prevWidth) {
    return true;
  }

  // Similarly, only update if the next height is greater than
  // the previous height.
  if (prevHeight && nextHeight && nextHeight > prevHeight) {
    return true;
  }
  var customizer = function customizer(oldProp, newProp, key) {
    // these keys are ignored from prop checking process
    if (key === "contentRect" || key === "measure" || key === "measureRef") {
      return true;
    }
    if (key === "children") {
      return oldProp == newProp;
    }
    if (key === "imgixParams") {
      return shallowEqual(oldProp, newProp, function (a, b) {
        if (Array.isArray(a)) {
          return shallowEqual(a, b);
        }
        return undefined;
      });
    }
    if (key === "htmlAttributes") {
      return shallowEqual(oldProp, newProp);
    }
    return undefined; // handled by shallowEqual
  };

  // If we made it here, we need to check if the "top-level"
  // props have changed (e.g. disableLibraryParam).
  var propsEqual = shallowEqual(props, nextProps, customizer);
  return !propsEqual;
};
var BackgroundImpl = /*#__PURE__*/function (_React$Component) {
  function BackgroundImpl(props) {
    _classCallCheck(this, BackgroundImpl);
    return _callSuper(this, BackgroundImpl, [props]);
  }
  _inherits(BackgroundImpl, _React$Component);
  return _createClass(BackgroundImpl, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return __shouldComponentUpdate(this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        measureRef = _this$props.measureRef,
        contentRect = _this$props.contentRect,
        _this$props$imgixPara = _this$props.imgixParams,
        imgixParams = _this$props$imgixPara === void 0 ? {} : _this$props$imgixPara,
        onLoad = _this$props.onLoad,
        disableLibraryParam = _this$props.disableLibraryParam,
        disablePathEncoding = _this$props.disablePathEncoding,
        src = _this$props.src,
        children = _this$props.children,
        _this$props$className = _this$props.className,
        className = _this$props$className === void 0 ? "" : _this$props$className;
      var forcedWidth = imgixParams.w,
        forcedHeight = imgixParams.h;
      var hasDOMDimensions = contentRect.bounds.width != null && contentRect.bounds.height != null;
      var htmlAttributes = this.props.htmlAttributes || {};
      var dpr = toFixed(2, imgixParams.dpr || global.devicePixelRatio || 1);
      var ref = htmlAttributes.ref;
      var onRef = function onRef(el) {
        measureRef(el);
        if (typeof ref === "function") {
          ref(el);
        }
      };
      var _ref = function () {
          var bothWidthAndHeightPassed = forcedWidth != null && forcedHeight != null;
          if (bothWidthAndHeightPassed) {
            return {
              width: forcedWidth,
              height: forcedHeight
            };
          }
          if (!hasDOMDimensions) {
            return {
              width: undefined,
              height: undefined
            };
          }
          var ar = contentRect.bounds.width / contentRect.bounds.height;
          var neitherWidthNorHeightPassed = forcedWidth == null && forcedHeight == null;
          if (neitherWidthNorHeightPassed) {
            var _width = findNearestWidth(contentRect.bounds.width);
            var _height = Math.ceil(_width / ar);
            return {
              width: _width,
              height: _height
            };
          }
          if (forcedWidth != null) {
            var _height2 = Math.ceil(forcedWidth / ar);
            return {
              width: forcedWidth,
              height: _height2
            };
          } else if (forcedHeight != null) {
            var _width2 = Math.ceil(forcedHeight * ar);
            return {
              width: _width2,
              height: forcedHeight
            };
          }
        }(),
        width = _ref.width,
        height = _ref.height;
      var isReady = width != null && height != null;
      var commonProps = _objectSpread({}, htmlAttributes);
      if (!isReady) {
        return /*#__PURE__*/React.createElement("div", _extends({}, commonProps, {
          className: "react-imgix-bg-loading ".concat(className),
          ref: onRef
        }), children);
      }
      var renderedSrc = function () {
        var _extractQueryParams = extractQueryParams(src),
          _extractQueryParams2 = _slicedToArray(_extractQueryParams, 2),
          rawSrc = _extractQueryParams2[0],
          params = _extractQueryParams2[1];
        var longImgixParams = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, params), {}, {
          fit: "crop"
        }, imgixParams), disableLibraryParam ? {} : {
          ixlib: "react-".concat(PACKAGE_VERSION)
        }), {}, {
          width: width,
          height: height,
          dpr: dpr
        });
        var srcOptions = {
          disablePathEncoding: disablePathEncoding
        };
        return constructUrl(rawSrc, longImgixParams, srcOptions);
      }();
      var style = _objectSpread(_objectSpread({}, htmlAttributes.style), {}, {
        backgroundImage: "url(".concat(renderedSrc, ")"),
        backgroundSize: (htmlAttributes.style || {}).backgroundSize !== undefined ? htmlAttributes.style.backgroundSize : "cover"
      });
      return /*#__PURE__*/React.createElement("div", _extends({}, commonProps, {
        className: className,
        ref: onRef,
        style: style
      }), children);
    }
  }]);
}(React.Component);
var Background = mergeComponentPropsHOF(processPropsHOF(withContentRect("bounds")(BackgroundImpl)));
export { Background, BackgroundImpl as __BackgroundImpl };
//# sourceMappingURL=react-imgix-bg.js.map